// Single-queue toast store, mirroring NoteView.swift's snackbar (one message at a time,
// auto-dismiss after a few seconds, replaces any pending message).

import { reactive, readonly } from "vue";

const state = reactive({
  message: "",
  variant: "info", // info | success | error
  visible: false,
});

let dismissTimer = null;

export function showSnack(message, options = {}) {
  if (!message) return;
  if (dismissTimer) {
    clearTimeout(dismissTimer);
    dismissTimer = null;
  }
  state.message = String(message);
  state.variant = options.variant || "info";
  state.visible = true;

  const duration = typeof options.duration === "number" ? options.duration : 2400;
  dismissTimer = setTimeout(() => {
    state.visible = false;
    dismissTimer = null;
  }, duration);
}

export function hideSnack() {
  if (dismissTimer) {
    clearTimeout(dismissTimer);
    dismissTimer = null;
  }
  state.visible = false;
}

export const snackState = readonly(state);
